// extracted by mini-css-extract-plugin
module.exports = {"Root__Form":"Gravityforms_Root__Form___Km8S","Root__Confirmation":"Gravityforms_Root__Confirmation__I4UCG","Root__Error":"Gravityforms_Root__Error__uYcDm"};